export const appAction = (type, data) => {
    return {
        type: type,
        payload: data,
    }
}